import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { APP } from 'src/Configs/App'

interface SpotifyArtist {
  name?: string
}

export interface SpotifyTrackResponse {
  id: string
  name: string
  duration_ms: number
  href: string
  artists: SpotifyArtist[]
  album: { images?: { url?: string; height?: number; width?: number }[] }
  preview_url?: string
}
export interface TiktokTrack {
  isOriginalSound?: boolean
  trackAuthorName?: string
  trackCoverUrl?: string
  trackDuration?: number
  trackPlayUrl?: string
  trackTiktokId: string
  trackTitle?: string
  trackUrl?: string
  initialVideoCount?: number
}

export interface Track {
  trackId?: string
  trackName?: string
  trackDuration?: string
  artistName?: string
  trackCoverUrl?: string
  trackPreviewUrl?: string
  trackDurationInMs?: number
}

export const firstTrackApi = createApi({
  reducerPath: 'firstTrackApi',
  tagTypes: ['Track'],
  baseQuery: fetchBaseQuery({ baseUrl: '' }),
  endpoints: (builder) => ({
    getFirstTikTokTrack: builder.query<TiktokTrack, string>({
      query: (trackId) => ({
        url: `${APP.TIKTOK_SERVER}/public/tiktok-search/tracks?search=https://www.tiktok.com/music/-${trackId}`,
      }),
      transformResponse: (response: TiktokTrack[]) => response[0] || {},
      providesTags: ['Track'],
    }),
  }),
})

export const { useGetFirstTikTokTrackQuery } = firstTrackApi
